var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingGraphicRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 85,
    viewBox: "0 0 56 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_962_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.7278 54.3219C50.7278 55.8712 49.4718 57.1273 47.9225 57.1273C46.3732 57.1273 45.1172 55.8712 45.1172 54.3219C45.1172 52.7726 46.3732 51.5166 47.9225 51.5166C49.4718 51.5166 50.7278 52.7726 50.7278 54.3219Z",
    fill: "#6C5DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7388 36.6201C34.8657 36.6201 39.1221 32.4605 39.1221 27.2368C39.1221 22.0131 34.9625 17.8535 29.7388 17.8535C24.5151 17.8535 20.3555 22.0131 20.3555 27.2368C20.3555 32.4605 23.3543 36.6201 29.7388 36.6201Z",
    fill: "#6C5DD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10212 65.2375L0.277344 58.6104L6.90445 50.7856L14.7292 57.4127L8.10212 65.2375Z",
    fill: "#030047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5331 20.6582L45.1172 25.3015L51.9854 31.2991L53.5331 20.6582Z",
    fill: "#030047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2177 15.434C42.2177 15.2405 42.121 15.1438 42.0242 14.9503L35.7364 7.11474C35.4462 6.82453 35.0593 6.72779 34.6723 7.018C34.3821 7.3082 34.2854 7.69515 34.5756 8.08209L40.8634 15.9176C41.1536 16.2078 41.5405 16.3046 41.9275 16.0144C42.121 15.8209 42.2177 15.6274 42.2177 15.434Z",
    fill: "#030047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2929 38.3609L16.2929 38.2642C16.1961 37.8773 15.8092 37.5871 15.4222 37.6838L10.5855 38.5544C10.1985 38.6511 9.90834 39.0381 10.0051 39.425C10.1018 39.8119 10.4888 40.1022 10.8757 40.0054L15.7124 39.1348C16.0027 39.0381 16.2929 38.7479 16.2929 38.3609Z",
    fill: "#030047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0533 68.5414C50.0533 68.2512 49.8598 67.961 49.5696 67.8643L39.4124 63.9948C39.0255 63.8981 38.6385 63.9949 38.445 64.3818C38.3483 64.7688 38.445 65.1557 38.832 65.3492L48.9892 69.2186C49.3761 69.3153 49.7631 69.2185 49.9565 68.8316C50.0533 68.7349 50.0533 68.6381 50.0533 68.5414Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_962_526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 56,
    fill: "white",
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 0 -24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingGraphicRight);
export default __webpack_public_path__ + "static/media/onboarding-graphic-right.7b61c61fe1a4346ca7641186e1ae189c.svg";
export { ForwardRef as ReactComponent };